import React, { Component } from "react";

import Detail from "../Detail/Detail";
import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

import analytics, { events } from "../../../utils/analytics";
import env from "../../../utils/env";

class UpgradeMembership extends Component {
  componentDidMount() {
    // Add Popupmaker class to trigger Wordpress Popup
    // In the future this shoul be replaced with a non-wp method
    //
    // For now it looks like this popup doesn't function as it should.
    // var element = document.getElementById("upgrade-cta");
    // element.classList.add("popmake-508");
  }

  render() {
    const { cta, desc, title } = this.props;

    return (
      <Detail icon={"fa-star"} title={title} description={desc}>
        <br />
        <Button
          type={buttonTypes.PRIMARY.value}
          action={actionTypes.CALL_TO_ACTION.value}
          label={cta}
          id={"upgrade-cta"}
          style={{ width: "100%" }}
          onClick={() => {
            analytics.track(events.CLICKED_ELEMENT, {
              element_name: "Upgrade Now",
              option_title: "Upgrade to Select for Perks"
            });
            window.location = `${env.envURL}/upgrade-confirmation`;
          }}
        />
      </Detail>
    );
  }
}

export default UpgradeMembership;



// WEBPACK FOOTER //
// ./src/Components/Header/UpgradeMembership/UpgradeMembership.js